import { useEffect } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import L from "leaflet";
import { Link } from "react-router-dom";

const WI_CENTER = [44.26, -88.3];

function pinIcon(truck) {
  const premium = truck.tier === "premium";
  const cls = !truck.is_live ? "gr-pin-off" : premium ? "gr-pin-premium" : "gr-pin-live";
  const letter = (truck.name || "?").charAt(0).toUpperCase();
  return L.divIcon({
    className: "gr-pin",
    html: `<div class="gr-pin-inner ${cls}">${letter}</div>`,
    iconSize: [40, 40],
    iconAnchor: [20, 20],
    popupAnchor: [0, -18],
  });
}

function FlyTo({ center }) {
  const map = useMap();
  useEffect(() => {
    if (center) map.flyTo(center, 13, { duration: 0.8 });
  }, [center, map]);
  return null;
}

export const MapView = ({ trucks, activeCenter }) => {
  const withCoords = trucks.filter((t) => t.lat != null && t.lng != null);
  return (
    <MapContainer center={WI_CENTER} zoom={9} className="w-full h-full" scrollWheelZoom>
      <TileLayer
        attribution='&copy; OpenStreetMap'
        url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png"
      />
      <FlyTo center={activeCenter} />
      {withCoords.map((t) => (
        <Marker key={t.id} position={[t.lat, t.lng]} icon={pinIcon(t)}>
          <Popup>
            <div className="min-w-[180px]">
              <p className="font-display font-extrabold text-base m-0">{t.name}</p>
              <p className="text-xs text-slate-500 m-0 mt-0.5">{t.cuisine} · {t.location_note || t.city}</p>
              <p className="text-xs m-0 mt-1">
                {t.is_live ? <span className="text-[#0FB5A6] font-bold">● Live now</span> : <span className="text-slate-400">Offline</span>}
                {t.hours ? ` · ${t.hours}` : ""}
              </p>
              <Link to={`/truck/${t.id}`} className="text-[#0FB5A6] font-bold text-xs no-underline">View profile →</Link>
            </div>
          </Popup>
        </Marker>
      ))}
    </MapContainer>
  );
};
